// src/services/bookingConfigurationService.js
export const getDefaultBookingConfig = (existingBook = {}) => ({
  // Core booking settings
  enableBooking: existingBook?.enableBooking || false,
  bookingOrgName: existingBook?.bookingOrgName || existingBook?.botName || '',
  bookingTimezone: existingBook?.bookingTimezone || 'Africa/Johannesburg',
  
  // Service types
  bookingServices: {
    appointment: false,
    consultation: false,
    class: false,
    facility: false,
    event: false,
    ...existingBook?.bookingServices
  },
  
  // Business hours (default 9-5 weekdays)
  businessHours: {
    monday: { enabled: true, start: '09:00', end: '17:00' },
    tuesday: { enabled: true, start: '09:00', end: '17:00' },
    wednesday: { enabled: true, start: '09:00', end: '17:00' },
    thursday: { enabled: true, start: '09:00', end: '17:00' },
    friday: { enabled: true, start: '09:00', end: '17:00' },
    saturday: { enabled: false, start: '09:00', end: '17:00' },
    sunday: { enabled: false, start: '09:00', end: '17:00' },
    ...existingBook?.businessHours
  },
  
  // Payment settings
  bookingPaymentMethod: existingBook?.bookingPaymentMethod || 'free',
  stripePublishableKey: existingBook?.stripePublishableKey || '',
  stripeSecretKey: existingBook?.stripeSecretKey || '',
  payfastMerchantId: existingBook?.payfastMerchantId || '',
  payfastMerchantKey: existingBook?.payfastMerchantKey || '',
  
  // Booking behavior
  defaultBookingDuration: existingBook?.defaultBookingDuration || 60,
  bookingBuffer: existingBook?.bookingBuffer || 15,
  requireBookingApproval: existingBook?.requireBookingApproval || false,
  sendBookingNotifications: existingBook?.sendBookingNotifications !== false,
  allowRescheduling: existingBook?.allowRescheduling !== false,
  enableBookingPortal: existingBook?.enableBookingPortal || false,
  
  // Time constraints
  maxAdvanceBookingDays: existingBook?.maxAdvanceBookingDays || 30,
  minAdvanceBookingHours: existingBook?.minAdvanceBookingHours || 2,
  
  // Policies
  cancellationPolicy: existingBook?.cancellationPolicy || 
    '24-hour notice required for cancellations. Late cancellations may incur charges.',
  bookingTerms: existingBook?.bookingTerms || '',
  
  // Staff and resources
  bookingStaff: existingBook?.bookingStaff || [],
  bookingResources: existingBook?.bookingResources || [],
  
  // Notifications
  notificationSettings: {
    sendConfirmationEmail: true,
    sendReminderEmail: true,
    reminderHours: 24,
    sendStaffNotifications: true,
    ...existingBook?.notificationSettings
  }
});

export const validateBookingConfig = (config) => {
  const errors = {};
  
  if (config.enableBooking) {
    if (!config.bookingOrgName?.trim()) {
      errors.bookingOrgName = 'Organization name is required when booking is enabled';
    }
    
    if (!config.bookingTimezone) {
      errors.bookingTimezone = 'Timezone is required';
    }
    
    // Check if at least one service type is enabled
    const hasEnabledService = Object.values(config.bookingServices || {}).some(enabled => enabled);
    if (!hasEnabledService) {
      errors.bookingServices = 'At least one service type must be enabled';
    }
    
    // Payment method validation
    if (config.bookingPaymentMethod === 'stripe') {
      if (!config.stripePublishableKey?.trim()) {
        errors.stripePublishableKey = 'Stripe publishable key is required';
      }
      if (!config.stripeSecretKey?.trim()) {
        errors.stripeSecretKey = 'Stripe secret key is required';
      }
    }
    
    if (config.bookingPaymentMethod === 'payfast') {
      if (!config.payfastMerchantId?.trim()) {
        errors.payfastMerchantId = 'PayFast merchant ID is required';
      }
      if (!config.payfastMerchantKey?.trim()) {
        errors.payfastMerchantKey = 'PayFast merchant key is required';
      }
    }
  }
  
  return errors;
};